import { Component } from "react";
import { ShieldAlert } from "lucide-react";

// Route-level safety net: a page crash must never black-screen the terminal.
// Renders a safe, non-financial error state; full stack stays in the console only.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("Page render failure:", error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="panel px-6 py-10 text-center" data-testid="error-boundary">
        <ShieldAlert className="w-8 h-8 text-amber-400 mx-auto mb-3" />
        <div className="font-display font-bold tracking-wide text-slate-100" data-testid="error-boundary-title">
          This panel hit an unexpected error
        </div>
        <p className="text-xs text-slate-500 mt-2 max-w-md mx-auto">
          No data was changed and no action was executed. Your accounts, ledger, and audit trail are unaffected.
        </p>
        <button
          data-testid="error-boundary-reload"
          onClick={() => window.location.reload()}
          className="mt-5 text-xs font-bold bg-[#D4AF37] text-[#0B0C0E] rounded-sm px-4 py-2 hover:bg-[#C5A059] transition-colors"
        >
          RELOAD PAGE
        </button>
      </div>
    );
  }
}
